var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_508_1850",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_508_1850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5498C11.8167 19.5498 11.6375 19.5248 11.4625 19.4748C11.2875 19.4248 11.125 19.3581 10.975 19.2748C10.2917 18.8581 9.575 18.5414 8.825 18.3248C8.075 18.1081 7.3 17.9998 6.5 17.9998C5.8 17.9998 5.1125 18.0914 4.4375 18.2748C3.7625 18.4581 3.11667 18.7164 2.5 19.0498C2.15 19.2331 1.8125 19.2248 1.4875 19.0248C1.1625 18.8248 1 18.5331 1 18.1498V6.09977C1 5.91644 1.04583 5.74144 1.1375 5.57477C1.22917 5.40811 1.36667 5.28311 1.55 5.19977C2.31667 4.79977 3.11667 4.49977 3.95 4.29977C4.78333 4.09977 5.63333 3.99977 6.5 3.99977C7.46667 3.99977 8.4125 4.12477 9.3375 4.37477C10.2625 4.62477 11.15 4.99977 12 5.49977V17.5998C12.85 17.0664 13.7417 16.6664 14.675 16.3998C15.6083 16.1331 16.55 15.9998 17.5 15.9998C18.1 15.9998 18.6875 16.0498 19.2625 16.1498C19.8375 16.2498 20.4167 16.3998 21 16.5998V4.59977C21.25 4.68311 21.4958 4.77061 21.7375 4.86227C21.9792 4.95394 22.2167 5.06644 22.45 5.19977C22.6333 5.28311 22.7708 5.40811 22.8625 5.57477C22.9542 5.74144 23 5.91644 23 6.09977V18.1498C23 18.5331 22.8375 18.8248 22.5125 19.0248C22.1875 19.2248 21.85 19.2331 21.5 19.0498C20.8833 18.7164 20.2375 18.4581 19.5625 18.2748C18.8875 18.0914 18.2 17.9998 17.5 17.9998C16.7 17.9998 15.925 18.1081 15.175 18.3248C14.425 18.5414 13.7083 18.8581 13.025 19.2748C12.875 19.3581 12.7125 19.4248 12.5375 19.4748C12.3625 19.5248 12.1833 19.5498 12 19.5498ZM14.825 14.2498C14.6583 14.3998 14.4792 14.4289 14.2875 14.3373C14.0958 14.2456 14 14.0914 14 13.8748V5.69977C14 5.63311 14.0125 5.57061 14.0375 5.51227C14.0625 5.45394 14.1 5.39977 14.15 5.34977L18.15 1.34977C18.3167 1.18311 18.5 1.14144 18.7 1.22477C18.9 1.30811 19 1.46644 19 1.69977V10.2748C19 10.3581 18.9833 10.4289 18.95 10.4873C18.9167 10.5456 18.875 10.5998 18.825 10.6498L14.825 14.2498Z",
    fill: "#707A8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.1a64e22b476ce66b35c548255331c921.svg";
export { ForwardRef as ReactComponent };